import PropTypes from 'prop-types';
import Skeleton from 'Components/Atoms/Skeleton/Skeleton';
import { cn } from 'Utils/cn';

export default function CardTransactionSkeleton(props) {
    const { className } = props;

    return (
        <div
            className={cn(
                'grid grid-cols-[20px_1fr_auto] gap-2 p-3 bg-white ring ring-gray-200 text-dark-blue text-left rounded-lg',
                className,
            )}
        >
            <div className="flex justify-center">
                <Skeleton variant="rounded" width={18} height={18} sx={{ borderRadius: 999 }} />
            </div>
            <div>
                <div>
                    <Skeleton variant="text" width={120} />
                </div>
                <div className="opacity-50">
                    <Skeleton variant="text" width={60} />
                </div>
            </div>
            <div>
                <div>
                    <Skeleton variant="text" width={40} />
                </div>
                <div>
                    <div className="opacity-50">
                        <Skeleton variant="text" width={40} />
                    </div>
                </div>
            </div>
        </div>
    );
}

CardTransactionSkeleton.propTypes = {
    className: PropTypes.string,
};
